import React from 'react';

export default function SettingsSkeleton() {
    return (
        <div className="p-8">
            {/* Welcome Section Skeleton */}
            <div className="mb-8">
                <div className="w-64 h-6 bg-gray-200 rounded animate-pulse mb-2"></div>
                <div className="w-96 h-4 bg-gray-200 rounded animate-pulse"></div>
            </div>

            {/* Account Management Skeleton */}
            <div className="bg-white border border-gray-200 rounded-xl p-6">
                <div className="w-40 h-5 bg-gray-200 rounded animate-pulse mb-6"></div>

                <div className="space-y-4">
                    {/* Account & Subscription Skeleton */}
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                        <div className="flex items-center space-x-3">
                            <div className="w-9 h-9 bg-gray-200 rounded-lg animate-pulse"></div>
                            <div>
                                <div className="w-40 h-4 bg-gray-200 rounded animate-pulse mb-2"></div>
                                <div className="w-48 h-3 bg-gray-200 rounded animate-pulse"></div>
                            </div>
                        </div>
                        <div className="flex items-center space-x-2">
                            <div className="w-2 h-2 bg-gray-200 rounded-full animate-pulse"></div>
                            <div className="w-16 h-6 bg-gray-200 rounded-full animate-pulse"></div>
                        </div>
                    </div>

                    {/* Billing & Subscription Skeleton */}
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                        <div className="flex items-center space-x-3">
                            <div className="w-9 h-9 bg-gray-200 rounded-lg animate-pulse"></div>
                            <div>
                                <div className="w-36 h-4 bg-gray-200 rounded animate-pulse mb-2"></div>
                                <div className="w-64 h-3 bg-gray-200 rounded animate-pulse"></div>
                            </div>
                        </div>
                        <div className="w-24 h-8 bg-gray-200 rounded-lg animate-pulse"></div>
                    </div>

                    {/* Help & Support Skeleton */}
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                        <div className="flex items-center space-x-3">
                            <div className="w-9 h-9 bg-gray-200 rounded-lg animate-pulse"></div>
                            <div>
                                <div className="w-28 h-4 bg-gray-200 rounded animate-pulse mb-2"></div>
                                <div className="w-56 h-3 bg-gray-200 rounded animate-pulse"></div>
                            </div>
                        </div>
                        <div className="w-28 h-8 bg-gray-200 rounded-lg animate-pulse"></div>
                    </div>

                    {/* Logout Skeleton */}
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                        <div className="flex items-center space-x-3">
                            <div className="w-9 h-9 bg-gray-200 rounded-lg animate-pulse"></div>
                            <div>
                                <div className="w-20 h-4 bg-gray-200 rounded animate-pulse mb-2"></div>
                                <div className="w-52 h-3 bg-gray-200 rounded animate-pulse"></div>
                            </div>
                        </div>
                        <div className="w-20 h-8 bg-gray-200 rounded-lg animate-pulse"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}
